import { render, staticRenderFns } from "./SetNameStep.vue?vue&type=template&id=3b4523d0&scoped=true&"
import script from "./SetNameStep.vue?vue&type=script&lang=ts&"
export * from "./SetNameStep.vue?vue&type=script&lang=ts&"
import style0 from "./SetNameStep.vue?vue&type=style&index=0&id=3b4523d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4523d0",
  null
  
)

export default component.exports